module.exports = __webpack_public_path__ + "static/media/CULTURE_MONITORING.bd800d8f.svg";